module.exports = __webpack_public_path__ + "media/audio31.96479218.mp3";